<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://garo.ca/" class="font-weight-bold ml-1" target="_blank">Bond Consulting</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <b-nav-item href="https://garo.ca/"  target="_blank">
              Developed By Garo
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
footer {
   position:fixed; 
  clear: both;
  left: 0;
  background-color: rgb(255, 255, 255) !important;
  bottom: 0 !important ;
  width: 100%;
  padding: 12px !important;
  font-size: 14px !important;
  /* z-index: -2; */
}
</style>
